class SidenavController {

    /**
     * Constructor class SidenavController
     *
     * @param {object} $scope
     */
    constructor($scope) {
        'ngInject';

    }
}

export default SidenavController;
